import {
  setCollectionsSortParams,
  setFilesSortParams,
} from '../actions/Sort';

import {
  getStore,
  isShare,
} from './App';
import { isAllFilesPage } from './Files';
import { getIntl } from './IntlInstance';
import { getSetting, getUserSetting } from './Settings';

export const goalSortSetting = (orderby, order = '') => {
  const intl = getIntl();

  const sortMap = {
    'position-asc': { key: 'position', label: intl.formatMessage({ defaultMessage: 'Custom (re-ordered)' }) },
    'relevance-asc': { key: 'relevance', label: intl.formatMessage({ defaultMessage: 'Relevance' }) },
    'original_datetime-desc': { key: 'newest_creation_date', label: intl.formatMessage({ defaultMessage: 'Newest (creation date)' }) },
    'created_at-desc': { key: 'newest_upload_date', label: intl.formatMessage({ defaultMessage: 'Newest (upload date)' }) },
    'original_datetime-asc': { key: 'oldest_creation_date', label: intl.formatMessage({ defaultMessage: 'Oldest (creation date)' }) },
    'created_at-asc': { key: 'oldest_upload_date', label: intl.formatMessage({ defaultMessage: 'Oldest (upload date)' }) },
    'favorites-desc': { key: 'favorites', label: intl.formatMessage({ defaultMessage: 'Favorites' }) },
    'size-asc': { key: 'size_smallest_first', label: intl.formatMessage({ defaultMessage: 'Size (smallest first)' }) },
    'size-desc': { key: 'size_larger_first', label: intl.formatMessage({ defaultMessage: 'Size (larger first)' }) },
    'name-asc': { key: 'a_z', label: intl.formatMessage({ defaultMessage: 'A-Z' }) },
    'name-desc': { key: 'z_a', label: intl.formatMessage({ defaultMessage: 'Z-A' }) },
    'faces-asc': { key: 'faces_asc', label: intl.formatMessage({ defaultMessage: 'Least identified' }) },
    'faces-desc': { key: 'faces_desc', label: intl.formatMessage({ defaultMessage: 'Most identified' }) },
    'updated_at-': { key: 'updated_at_', label: intl.formatMessage({ defaultMessage: 'Recently updated' }) },
    'duplicates_size-': { key: 'duplicates_size_', label: intl.formatMessage({ defaultMessage: 'Size' }) },
  };

  return sortMap[`${orderby}-${order}`] || null;
};

export const getDefaultSortParams = (scope, defaultorderby = 'created_at', defaultOrder = 'desc') => {
  const workspaceSetting = getSetting('default_sort');
  const userSetting = getUserSetting('default_sort');

  const defaultSort = {
    orderby: defaultorderby,
    order: defaultOrder,
  };

  let value = defaultSort;

  const filesSortMap = {
    newest_creation_date: { orderby: 'original_datetime', order: 'desc' },
    newest_upload_date: { orderby: 'created_at', order: 'desc' },
    oldest_creation_date: { orderby: 'original_datetime', order: 'asc' },
    oldest_upload_date: { orderby: 'created_at', order: 'asc' },
    favorites: { orderby: 'favorites', order: 'desc' },
    size_smallest_first: { orderby: 'size', order: 'asc' },
    size_larger_first: { orderby: 'size', order: 'desc' },
    a_z: { orderby: 'name', order: 'asc' },
    z_a: { orderby: 'name', order: 'desc' },
  };

  const collectionFilesSortMap = {
    position: { orderby: 'position', order: 'asc' },
    ...filesSortMap,
  };

  const collectionsSortMap = {
    position: { orderby: 'position', order: 'asc' },
    newest_creation_date: { orderby: 'created_at', order: 'desc' },
    newest_upload_date: { orderby: 'created_at', order: 'desc' },
    oldest_creation_date: { orderby: 'created_at', order: 'asc' },
    oldest_upload_date: { orderby: 'created_at', order: 'asc' },
    a_z: { orderby: 'name', order: 'asc' },
    z_a: { orderby: 'name', order: 'desc' },
  };

  if (workspaceSetting || userSetting) {
    const settingValue = !userSetting || userSetting === 'workspace' ? workspaceSetting : userSetting;

    if (scope === 'files') {
      if (isAllFilesPage()) {
        value = filesSortMap[settingValue] || defaultSort;
      } else {
        value = collectionFilesSortMap[settingValue] || defaultSort;
      }
    } else {
      value = collectionsSortMap[settingValue] || defaultSort;
    }
  }

  return value;
};

export const handleSortParams = () => {
  if (isShare()) {
    return;
  }

  const { dispatch } = getStore();

  const filesParams = getDefaultSortParams('files');
  const collectionsParams = getDefaultSortParams('collections');
  dispatch(setFilesSortParams({
    orderby: filesParams.orderby,
    order: filesParams.order,
  }));
  dispatch(setCollectionsSortParams({
    orderby: collectionsParams.orderby,
    order: collectionsParams.order,
  }));
};
